import Cookies from 'js-cookie'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',

  fixedHeader: true,
  sidebarLogo: true
}

const mutations = {
  toggleSidebar: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  closeSideBar: (state, { withoutAnimation }) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  toggleDevice: (state, device) => {
    state.device = device
  },
  toggleHeader: (state, bool) => {
    console.log(bool);
    state.fixedHeader = bool
  },
  toggleSidebarLogo: (state, bool) => {
    state.sidebarLogo = bool
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
